import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { Project } from "../../../interfaces/Projects/projects";
import GenericPromises from "../../../api/GenericPromises";
import { Menuitem } from "../../../interfaces/Security/menu";
import useSnackBar from "../../../components/Commons/SnackBar/useSnackBar";
import { usePermissions } from "../../../hooks/usePermissions";
import { Spinner } from "../../../components/Commons/Spinner/Spinner";
import { Header } from "../../../components/Header";
import { ButtonLoading, ButtonStyled } from "../../../theme/buttons";
import {
  Box,
  Button,
  Grid,
  ListItemButton,
  Popover,
  Switch,
  Typography,
} from "@mui/material";
import { GenericDialog } from "../../../components/Dialogs/Dialog";
import { UpdateProject } from "./update";
import TabsProjectsDetails from "./tabsDetails";
import { TableProjectExtraFields } from "../Catalogs/ProjectExtraFields/table";
import { TableProjectGroups } from "../Catalogs/ProjectGroups/table";
import { ProjectRelatedInvoices } from "../Catalogs/ProjectRelatedInvoices";
import { GridRowsProp, GridValidRowModel } from "@mui/x-data-grid";
import { ProjectExtraField } from "../../../interfaces/Projects/Catalogs/projectExtraFields";
import { useParamsFilter } from "../../../hooks/useParamsFilter";
import { SalesInvoice } from "../../../interfaces/Sales/Invoices/salesinvoices";
import { PurchaseInvoice } from '../../../interfaces/Purchases/Invoices/purchaseInvoices';
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import DisabledByDefaultIcon from '@mui/icons-material/DisabledByDefault';
import { TabProjectDocuments } from "../Catalogs/ProjectDocuments/table";
import FunctionsIcon from '@mui/icons-material/Functions';
import { useCalculateFormulasProjects } from "./components/helpers/hookCalculateFormulas/hookCalculateFormulas";
import { Parameter } from "../../../interfaces/Commons/parameters";
import { useFormulaEvaluator } from "../../../hooks/useFormulaEvaluator";
import { useBase64 } from "../../../hooks/useBase64";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { DialogEntity } from "../../../components/Dialogs/DialogEntity";
import CropSquareIcon from '@mui/icons-material/CropSquare';


interface UpdateProjectHandle {
  onCloseProject?: () => void;
}

export const ViewProjects = () => {
  const [t] = useTranslation("global");
  const location = useLocation();
  const navigate = useNavigate();
  const { GetResourceByUrl } = usePermissions();
  const { utf8ToBase64 } = useBase64();
  const { showSnackBar, SnackbarComponent } = useSnackBar();
  const { GetParamsFromBase64 } = useParamsFilter();
  const { GenericGetResource, GenericDeleteResource, GenericPutAction } = GenericPromises();
  const { fetchParameters } = useFormulaEvaluator();
  const { CheckAndValidateFormulasPerProject } = useCalculateFormulasProjects();
  const invoiceDocumentStatusActiveId = 1;
  const [projectLocal, setProjectLocal] = useState<Project>();
  const [openDialog, setOpenDialog] = useState(false);
  const [dataloaded, setDataLoaded] = useState(false);
  const [isClosedProject, setIsClosedProject] = useState(false);
  const [loadingPut, setLoadingPut] = useState(false);
  const [isUpdateProjectExtraFields, setIsUpdateProjectExtraFields] = useState(true);
  const [openDialogAddStages, setOpenDialogAddStages] = useState(false);
  const [resourceScreen, setResourceScreen] = useState<Menuitem>();
  const [resourceProjectExtraFields, setResourceProjectExtraFields] = useState<Menuitem>();
  const [resourceClosedProject, setResourceClosedProject] = useState<Menuitem>();
  const [resourceOpenProject, setResourceOpenProject] = useState<Menuitem>();
  const [resourceCalculateCost, setResourceCalculateCost] = useState<Menuitem>();
  const [resourceAddStagesByProjectId, setResourceAddStagesByProjectId] = useState<Menuitem>();
  const [purchaseInvoicesData, setPurchaseInvoicesData] = useState<GridRowsProp>([]);
  const [salesInvoicesData, setSalesInvoicesData] = useState<GridRowsProp>([]);
  const [projectExtraFieldsData, setProjectExtraFieldsData] = useState<ProjectExtraField[]>([]);
  const [totalSales, setTotalSales] = useState(0);
  const [totalPurchases, setTotalPurchases] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [anchorEl1, setAnchorEl1] = useState<HTMLButtonElement | null>(null);
  const [projectUserClosed, setProjectUserClosed] = useState<String | undefined>();
  const [projectUserDateClosed, setProjectUserDateClosed] = useState<Date | undefined>();
  const open1 = Boolean(anchorEl1);
  const id1 = open1 ? "simple-popover" : undefined;
  const UpdateProjectRef = useRef<UpdateProjectHandle>(null);
  const [hasPurchaseOrSalesInvoices, setHasPurchaseOrSalesInvoices] = useState(false);
  const [dialogConfirmCloseProject, setDialogConfirmCloseProject] = useState(false);
  const [dialogConfirmOpenProject, setDialogConfirmOpenProject] = useState(false);
  const [resourceSalesInvoices, setResourceSalesInvoices] = useState<Menuitem>();
  const [resourcePurchaseInvoices, setResourcePurchaseInvoices] = useState<Menuitem>();
  const [resourceScreenDocuments, setResourceScreenDocuments] = useState<Menuitem>();
  const [resourceScreenGroup, setResourceScreenGroup] = useState<Menuitem>()
  const [resourceScreenExtraField, setResourceScreenExtraField] = useState<Menuitem>()
  const [defaultFilter, setDefaultFilter] = useState<{
    columnfilter: string;
    value: string;
  }[]>([])

  const onDelete = async () => {
    let canDelete = true;
    let myPromises = [
      GenericGetResource(
        `/purchaseinvoices/byprojectid/${projectLocal?.project_id}`
      ),
      GenericGetResource(
        `/salesinvoices/byprojectid/${projectLocal?.project_id}`
      ),
      GenericGetResource(
        `/projectdocuments/byprojectid/${projectLocal?.project_id}`
      ),
    ];
    await Promise.all(myPromises)
      .then((responses) => {
        if (responses[0].data.data.length > 0) {
          showSnackBar(`${t("projects.info.there_are_purchase_invoices")}`, 'warning');
          canDelete = false;
        }
        if (responses[1].data.data.length > 0) {
          showSnackBar(`${t("projects.info.there_are_payment_invoices")}`, 'warning');
          canDelete = false;
        }
        if (responses[2].data.data.length > 0) {
          showSnackBar(`${t("projects.info.there_are_documents")}`, 'warning');
          canDelete = false;
        }
      }).catch((error) => {
        showSnackBar(error.message, "error");
        setOpenDialog(false);
      });

    if (!canDelete) {
      setOpenDialog(false);
      return;
    }

    GenericDeleteResource(`/projects/${projectLocal?.project_id}`)
      .then(() => {
        setOpenDialog(false);
        navigate("/projects", { state: { method: "delete" }, replace: true });
      })
      .catch((error) => {
        showSnackBar(error.message, "error");
        setOpenDialog(false);
      });
  };

  const ValidateResourceCalculateFormulas = async () => {
    GetResourceByUrl(`/projectextrafields/updateprojectextrafields/byprojectid`)
      .then((responsePermissions: Menuitem) => {
        if (responsePermissions.update === true) {
          onCalculateFormulas();
        }
        else {
          showSnackBar(t("generic.snackbar.unauthorize"), "error");
        }
      })
      .catch((error) => {
        showSnackBar(error.message, "error");
      });
  }

  const AddStagesByProjectId = async () => {
    setLoadingPut(true);
    await GenericPutAction(`/projects/addstagesbyprojectid/${projectLocal?.project_id}`, null, false)
      .then(() => {
        showSnackBar(t("projects.info.added-stages"), "success");
        setOpenDialogAddStages(false);
        handleClose1();
      })
      .catch((error) => showSnackBar(error.message, 'error'))
      .finally(() => setLoadingPut(false));
  }

  const CalculateTotals = (
    myPurchaseInvoices: SalesInvoice[] | readonly GridValidRowModel[],
    mySalesInvoices: PurchaseInvoice[] | readonly GridValidRowModel[]
  ) => {
    let mySalesTotals = 0;
    let myPurchasesTotals = 0;

    for (const item of mySalesInvoices) {
      mySalesTotals += (item.exchange_rate ?? 0) * (item.total_amount ?? 0);
    }

    for (const item of myPurchaseInvoices) {
      myPurchasesTotals += (item.exchange_rate ?? 0) * (item.total_amount ?? 0);
    }

    setTotalPurchases((prev) => myPurchasesTotals);
    setTotalSales((prev) => mySalesTotals);
    setTotalAmount((prev) => mySalesTotals - myPurchasesTotals);
  };

  const handleClick1 = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl1(event.currentTarget);
  };

  const handleClose1 = () => {
    setAnchorEl1(null);
  };

  const loadPurchaseInvoices = async () => {
    await GenericGetResource(`/purchaseinvoices?filter=${utf8ToBase64(`invoice_doc_status_id=1&project_id=${projectLocal?.project_id ?? 0}`)}`)
      .then((responsePurchaseInvoices) => {
        setPurchaseInvoicesData(responsePurchaseInvoices.data.data);
        CalculateTotals(responsePurchaseInvoices.data.data, salesInvoicesData);
      });
  }

  const onCalculateFormulas = async () => {
    await setIsClosedProject((prev) => !prev);
    await setIsUpdateProjectExtraFields((prev) => false);
    let myComboParameters: Parameter[] = await fetchParameters();
    try {
      await CheckAndValidateFormulasPerProject(projectLocal, projectExtraFieldsData, true, myComboParameters);
      await loadPurchaseInvoices();
      await setIsUpdateProjectExtraFields((prev) => true);
      await setIsClosedProject((prev) => !prev);
    } catch {
      await loadPurchaseInvoices();
      await setIsUpdateProjectExtraFields((prev) => true);
      await setIsClosedProject((prev) => !prev);
    }
  }

  useEffect(() => {
    let projectId;
    if (location.search.length > 0 && location.state === null) {
      let myParams = GetParamsFromBase64();
      projectId = myParams.get("project_id");
    }

    if (location.state === null && !projectId) {
      return navigate("/projects", { state: {}, replace: true });
    }

    GenericGetResource(`/projects/${(location.state && location.state.row.project_id) ?? projectId}`)
      .then(async (responseProject) => {
        setProjectLocal(responseProject.data);
        setIsClosedProject(responseProject.data.project_is_closed);
        let myPromises = [
          GenericGetResource(`/projectextrafields/byprojectid/${responseProject.data.project_id}`),
          GenericGetResource(`/invoicedocumentstatus`)
        ];
        await Promise.all(myPromises)
          .then((responses) => {
            responses[0] && setProjectExtraFieldsData((prev) => responses[0].data.data);
          })
          .catch((error) => {
            showSnackBar(error.message, "error");
          });
        let myPermissions = [
          GetResourceByUrl(`/projects`),
          GetResourceByUrl(`/projectextrafields`),
          GetResourceByUrl(`/projects/isclosed`),
          GetResourceByUrl(`/projectextrafields/updateprojectextrafields/byprojectid`),
          GetResourceByUrl("/purchaseinvoices"),
          GetResourceByUrl("/salesinvoices"),
          GetResourceByUrl("/projectdocuments"),
          GetResourceByUrl(`/projectgroups`),
          GetResourceByUrl(`/projectextrafields`),
          GetResourceByUrl(`/projects/addstagesbyprojectid`),
          GetResourceByUrl(`/projects/openproject`),
        ];
        await Promise.all(myPermissions)
          .then(async (responsePermissions) => {
            responsePermissions[0] && setResourceScreen((prev) => responsePermissions[0]);
            responsePermissions[1] && setResourceProjectExtraFields((prev) => responsePermissions[1]);
            responsePermissions[2] && setResourceClosedProject((prev) => responsePermissions[2]);
            responsePermissions[3] && setResourceCalculateCost((prev) => responsePermissions[3]);
            responsePermissions[4] && setResourcePurchaseInvoices((prev) => responsePermissions[4]);
            responsePermissions[5] && setResourceSalesInvoices((prev) => responsePermissions[5]);
            responsePermissions[6] && setResourceScreenDocuments((prev) => responsePermissions[6]);
            responsePermissions[7] && setResourceScreenGroup((prev) => responsePermissions[7]);
            responsePermissions[8] && setResourceScreenExtraField((prev) => responsePermissions[8]);
            responsePermissions[9] && setResourceAddStagesByProjectId((prev) => responsePermissions[9]);
            responsePermissions[10] && setResourceOpenProject((prev) => responsePermissions[10]);

            //Get Data of invoices
            let dataPurchase: PurchaseInvoice[] = [];
            let dataSale: SalesInvoice[] = [];
            if (responsePermissions[4] && responsePermissions[4].read) {
              await GenericGetResource(`/purchaseinvoices?filter=${utf8ToBase64(`project_id=${responseProject.data.project_id}&invoice_doc_status_id=${invoiceDocumentStatusActiveId}`)}`).then((responsePurchase) => {
                setPurchaseInvoicesData((prev) => responsePurchase.data.data);
                dataPurchase = responsePurchase.data.data
              })
            }
            if (responsePermissions[5] && responsePermissions[5].read) {
              await GenericGetResource(`/salesinvoices?filter=${utf8ToBase64(`project_id=${responseProject.data.project_id}&invoice_doc_status_id=${invoiceDocumentStatusActiveId}`)}`).then((reponseSales) => {
                setSalesInvoicesData((prev) => reponseSales.data.data);
                dataSale = reponseSales.data.data
              })
            }
            if (dataPurchase.length > 0 || dataSale.length > 0) {
              setHasPurchaseOrSalesInvoices(true);
            }
            CalculateTotals(dataPurchase, dataSale);
          }).catch((error) => {
            showSnackBar(error.message, "error");
          });
        setDataLoaded(true);
      })
      .catch((error) => {
        showSnackBar(error.message, "error");
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (salesInvoicesData.length > 0 || purchaseInvoicesData.length > 0) {
      setHasPurchaseOrSalesInvoices(true);
    } else {
      setHasPurchaseOrSalesInvoices(false);
    }
  }, [salesInvoicesData, purchaseInvoicesData]);

  useEffect(() => { }, [isUpdateProjectExtraFields]);

  return (
    <>
      {!dataloaded && <Spinner />}
      {dataloaded && (
        <>
          <Header
            title={t("projects.title-view")}
            child={
              <div className="d-flex justify-content-end">
                <div className="d-flex flex-row-reverse">
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      paddingLeft: 2,
                    }}
                  >
                    <Typography>
                      {t("projects.fields.project_is_closed")}
                    </Typography>
                    <Switch
                      readOnly={true}
                      disabled={true}
                      checked={isClosedProject}
                    />
                  </Box>

                  <Popover
                    id={id1}
                    open={open1}
                    anchorEl={anchorEl1}
                    onClose={handleClose1}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "left",
                    }}
                    sx={{ minWidth: 200 }}
                  >
                    <ListItemButton
                      onClick={() => setDialogConfirmCloseProject(true)}
                      sx={{
                        p: 2,
                        display: "flex",
                        justifyContent: "space-between",
                        minWidth: 200,
                      }}
                      disabled={
                        !resourceClosedProject?.update ? true : isClosedProject
                      }
                    >
                      {t("projects.actions.closeProject")}
                      <DisabledByDefaultIcon />
                    </ListItemButton>
                    <ListItemButton
                      onClick={() => setDialogConfirmOpenProject(true)}
                      sx={{
                        p: 2,
                        display: "flex",
                        justifyContent: "space-between",
                        minWidth: 200,
                      }}
                      disabled={
                        !resourceOpenProject?.update ? true : !isClosedProject
                      }
                    >
                      {t("projects.actions.open-project")}
                      <CropSquareIcon />
                    </ListItemButton>
                    <ListItemButton
                      onClick={() => ValidateResourceCalculateFormulas()}
                      sx={{
                        p: 2,
                        display: "flex",
                        justifyContent: "space-between",
                        minWidth: 200,
                      }}
                      disabled={
                        !resourceCalculateCost?.update ? true : isClosedProject
                      }
                    >
                      {t("projects.actions.calculate-cost")}
                      <FunctionsIcon />
                    </ListItemButton>
                    <ListItemButton
                      onClick={() => setOpenDialogAddStages(true)}
                      sx={{
                        p: 2,
                        display: "flex",
                        justifyContent: "space-between",
                        minWidth: 200,
                      }}
                      disabled={
                        !resourceAddStagesByProjectId?.update ? true : isClosedProject
                      }
                    >
                      {t("projects.actions.add-stages")}
                      <AddCircleOutlineIcon />
                    </ListItemButton>
                  </Popover>
                  {isClosedProject && (
                    <div className="d-flex justify-content-center align-items-center">
                      {projectUserClosed && (
                        <Grid item marginInline={1}>
                          <Typography fontWeight={"bold"}>
                            {projectUserClosed}
                          </Typography>
                        </Grid>
                      )}
                      {projectUserDateClosed && (
                        <Grid item marginInline={1}>
                          <Typography fontWeight={"bold"}>
                            {projectUserDateClosed?.toLocaleString()}
                          </Typography>
                        </Grid>
                      )}
                    </div>
                  )}
                </div>
                <div className="d-flex flex-row-reverse m-1">
                  <Button
                    variant="outlined"
                    aria-describedby={id1}
                    onClick={handleClick1}
                    disabled={loadingPut}
                  >
                    <MoreHorizIcon />
                  </Button>
                  {resourceScreen?.delete === true && (
                    <ButtonStyled
                      variant="contained"
                      className="my-1"
                      onClick={() => setOpenDialog(true)}
                      disabled={isClosedProject}
                    >
                      {t("generic.buttons.delete")}
                    </ButtonStyled>
                  )}
                  <Button
                    variant="text"
                    onClick={() => {
                      navigate("/projects", { replace: true });
                    }}
                  >
                    {t("generic.buttons.goback")}
                  </Button>
                </div>
              </div>
            }
          />

          {resourceScreen?.read && (
            <>
              <UpdateProject
                ref={UpdateProjectRef}
                projectPayload={projectLocal ?? {}}
                isEditProps={resourceScreen?.update}
                totalSales={totalSales}
                totalPurchases={totalPurchases}
                totalAmount={totalAmount}
                projectExtraFieldsData={projectExtraFieldsData}
                setProjectExtraFieldsData={setProjectExtraFieldsData}
                resourceProjectExtraFields={resourceProjectExtraFields}
                resourceClosedProject={resourceClosedProject}
                setIsClosedProject={setIsClosedProject}
                isClosedProject={isClosedProject}
                setProjectUserClosed={setProjectUserClosed}
                setProjectUserDateClosed={setProjectUserDateClosed}
                isUpdateProjectExtraFields={isUpdateProjectExtraFields}
                setIsUpdateProjectExtraFields={setIsUpdateProjectExtraFields}
                showSnackBar={showSnackBar}
                setDialogConfirmCloseProject={setDialogConfirmCloseProject}
                dialogConfirmCloseProject={dialogConfirmCloseProject}
                dialogConfirmOpenProject={dialogConfirmOpenProject}
                setDialogConfirmOpenProject={setDialogConfirmOpenProject}
              />
              <div className="my-4" />
              <TabsProjectsDetails
                isReadDocument={resourceScreenDocuments?.read}
                isProjectGroup={resourceScreenGroup?.read}
                isExtraField={resourceScreenExtraField?.read}
                ProjectGroups={
                  <TableProjectGroups
                    project_id={projectLocal?.project_id ?? 0}
                    project_name={projectLocal?.project_name ?? ""}
                    isClosedProject={isClosedProject}
                    resourceScreenGroup={resourceScreenGroup}
                  />
                }
                ProjectExtraFields={
                  <TableProjectExtraFields
                    projectExtraFieldsData={projectExtraFieldsData}
                    setProjectExtraFieldsData={setProjectExtraFieldsData}
                    project_id={projectLocal?.project_id ?? 0}
                    isClosedProject={isClosedProject}
                    showSnackBar={showSnackBar}
                    resourceScreenExtraField={resourceScreenExtraField}
                  />
                }
                RelatedInvoices={
                  <ProjectRelatedInvoices
                    projectPayload={projectLocal ?? {}}
                    purchaseInvoicesData={purchaseInvoicesData}
                    salesInvoicesData={salesInvoicesData}
                    isClosedProject={isClosedProject}
                    defaultFilter={defaultFilter}
                    resourceSalesInvoices={resourceSalesInvoices}
                    resourcePurchaseInvoices={resourcePurchaseInvoices}
                  />
                }
                Documents={
                  <TabProjectDocuments
                    resourceScreenDocuments={resourceScreenDocuments}
                    showSnackBar={showSnackBar}
                    project_id={projectLocal?.project_id ?? 0}
                    isClosedProject={isClosedProject}
                  />
                }
              />
            </>
          )}
        </>
      )}
      <GenericDialog
        title={t("generic.dialog.delete")}
        content={t("projecttypes.dialog.delete")}
        open={openDialog}
        setOpen={setOpenDialog}
        onAcept={onDelete}
      />
      <DialogEntity
        open={openDialogAddStages}
        title={<Header title={t("projects.actions.add-stages")} />}
        maxWidth={"sm"}
        fullWidth
        content={
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Box sx={{ display: "flex", flexDirection: "row-reverse" }}>
              <ButtonLoading variant="outlined" isLoading={loadingPut} onClick={() => AddStagesByProjectId()}>
                {t("generic.buttons.accept")}
              </ButtonLoading>
              <Button onClick={() => setOpenDialogAddStages(false)} variant="outlined" disabled={loadingPut}>{t("generic.buttons.cancel")}</Button>
            </Box>
          </Box>
        }
      />
      <SnackbarComponent />
    </>
  );
};
